import { PlayListNodeUploadDto, PlaylistUploadDto } from "collaboration-service";
import { PlaylistEditActions, PlaylistEditState, PLENodeMissing, useDispatchPLE } from "./PlaylistEdit";
import * as _ from "lodash";

const generalSettings = (playlist: PlaylistUploadDto): PlaylistEditState["missing"]["generalSettings"] => {
    const toRet: PlaylistEditState["missing"]["generalSettings"] = {};
    const { headlines, media, group_id } = playlist;

    if (!group_id || group_id.length === 0) {
        toRet.groupId = true;
    }
    if (headlines.length === 0 || !headlines.some(h => h.text && h.text.trim() !== "")) {
        toRet.headline = true;
    }

    // console.log("media", media);

    if ((!media || !media.reference) && !(media as any)?.file) {
        toRet.media = true;
    }
    return toRet;
}

const content = (playlist: PlaylistUploadDto): PlaylistEditState["missing"]["content"] => {
    const toRet: PlaylistEditState["missing"]["content"] = {};
    if (!playlist.contents || playlist.contents.length === 0) {
        toRet.contents = true;
    }
    return toRet;
}

const nodeMissing = (node: PlayListNodeUploadDto): { missing: PLENodeMissing, failure: boolean } => {
    const toRet: { missing: PLENodeMissing, failure: boolean } = { missing: {}, failure: false };

    const { headlines, children, referenceIds, color } = node;

    const successor = children?.[0];
    const successorReferenceValue = successor?.referenceValue;

    //return errorNode;
    if (!headlines || headlines.length === 0)
        toRet.missing.headlines = true;
    if (!color)
        toRet.missing.color = true;
    if (!referenceIds || referenceIds.length === 0)
        toRet.missing.referenceIds = true;

    if ((successor?.transitionFunction === "ReferenceDoneWithValue" || successor?.transitionFunction === "PercentageDone" || successor?.transitionFunction === "AbsCountDone")
        && (successorReferenceValue === undefined || successorReferenceValue === 0 || Number.isNaN(successorReferenceValue)))
        toRet.missing.successorReferenceValue = true;

    if ((successorReferenceValue !== undefined && successor?.transitionFunction === "AbsCountDone") && referenceIds && successorReferenceValue > referenceIds.length)
        toRet.missing.absCountDone = true;

    if (successor) {
        let numberTooHigh = (successorReferenceValue && node?.referenceIds && successor?.transitionFunction === "AbsCountDone")
            ? successorReferenceValue > (node.referenceIds?.length || 0)
            : ((successorReferenceValue === undefined || successorReferenceValue === 0 || Number.isNaN(successorReferenceValue)) ? true : false);
        if (successor?.transitionFunction === "ReferenceDoneWithValue")
            numberTooHigh = successorReferenceValue === undefined ? true : ((successorReferenceValue > 0 && successorReferenceValue <= 100) ? false : true);
        if (successor?.transitionFunction === "PercentageDone")
            numberTooHigh = successorReferenceValue === undefined ? true : ((successorReferenceValue > 0 && (successorReferenceValue * 100) <= 100) ? false : true);
        if (successor?.transitionFunction === "FallThru")
            numberTooHigh = false;
        if (numberTooHigh)
            toRet.missing.numberTooHigh = true
        if (successor?.transitionFunction === "ReferenceDone" || successor?.transitionFunction === "ReferenceDoneWithValue") {
            const referenceContentIds: string[] = [];
            if (node?.children) {
                if (node?.children[0].referenceContentId)
                    referenceContentIds.push(node?.children[0].referenceContentId)
                if (node?.children[0].referenceContentIds)
                    referenceContentIds.push(...node?.children[0].referenceContentIds)
            }
            if (referenceContentIds.length === 0) {
                toRet.missing.missingNode = true;
            }
        }
    }

    toRet.missing.missingDuration = node.durationInMinutes === undefined || node.durationInMinutes === 0;
    toRet.missing.missingRelativeDueDate = node.dueDateRelativeTo === undefined ? false : ((node.dueDateRelativeTo === "NodeAssignment" || node.dueDateRelativeTo === "NodeFirstItemStart" || node.dueDateRelativeTo === "PlaylistAssignment") && (node.dueDateRelativeInHours === undefined || node.dueDateRelativeInHours === 0));
    toRet.missing.missingAbsoluteDueDate = node.dueDateRelativeTo === undefined ? false : (node.dueDateRelativeTo === "Absolute" && (node.absDueDate === undefined || node.absDueDate === null));
    toRet.missing.missingDueDateRelativeTo = node.dueDateRelativeTo === null || node.dueDateRelativeTo === undefined;

    toRet.failure = _.some(toRet.missing, (val) => val === true);
    return toRet;
}

const phases = (playlist: PlaylistUploadDto): PlaylistEditState["missing"]["phases"] => {
    const toRet: PlaylistEditState["missing"]["phases"] = { nodes: {} };
    let cur = playlist.startNode;
    if (cur === undefined || cur === null) {
        toRet.startNode = true;
        return toRet;
    }
    while (cur !== undefined) {
        const res = nodeMissing(cur);
        toRet.nodes[cur.id ?? ""] = res.missing
        toRet.nodeMissing = toRet.nodeMissing || res.failure;
        cur = cur.children?.[0]?.to;
    }

    return toRet;
}

const useCalcMissingForPlaylistEdit = (playlist: PlaylistUploadDto | undefined, oldMissing: PlaylistEditState["missing"]) => {
    const dispatchPLE = useDispatchPLE();
    if (!playlist)
        return;

    const missing: PlaylistEditState["missing"] = {
        generalSettings: generalSettings(playlist),
        content: content(playlist),
        phases: phases(playlist),
        automation: {},
        access: {},
    };





    //console.log("playlist", playlist);
    if (!playlist.contents || playlist.contents.length === 0) {
        missing.content.contents = true;
    }

    //console.log("missing", _.clone(missing));
    if (!_.isEqual(missing, oldMissing))
        dispatchPLE(PlaylistEditActions.setMissing(missing));
}

export default useCalcMissingForPlaylistEdit;